'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var SelectList_module = require('./SelectList.module.css.js');
var index = require('../StyledMarkup/index.js');
var SelectItem = require('../SelectItem/SelectItem.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const SelectListButton = _ref => {
  let {
    onChange,
    option: {
      value,
      label,
      disabled
    },
    selection
  } = _ref;
  const {
    panelcontainerNoneNone,
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const handleClick = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  return /*#__PURE__*/React__default["default"].createElement(SelectItem["default"], {
    className: SelectList_module["default"].selectListOption,
    customStyle: {
      ...panelcontainerNoneNone,
      padding: '0.875rem 1rem',
      flexGrow: '1',
      textAlign: 'start',
      fontWeight: 'inherit',
      margin: 0,
      ...bodytextDefaultNone
    },
    key: value,
    onClick: () => handleClick(value),
    selected: selection === value,
    disabled: disabled
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    content: label
  }));
};
const SelectList = _ref2 => {
  let {
    options,
    onChange,
    selection
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: SelectList_module["default"].selectList
  }, options.map(option => /*#__PURE__*/React__default["default"].createElement(SelectListButton, {
    option,
    onChange,
    selection,
    key: option.value
  })));
};
var SelectList$1 = nthHookTheme.withThemeProvider(SelectList, {
  themeTokens: ['panelcontainerNoneNone', 'bodytextDefaultNone']
});

exports["default"] = SelectList$1;
